import { zipObject } from 'es-toolkit';

import userRoleFilter from '../filters/userRole';

export default class UserRole {

    static GROWER = 'GROWER';
    static ADMIN = 'ADMIN';
    static VIEWER = 'VIEWER';

    static options(): Record<string, string> {

        const keys = Object.keys(UserRole);

        return zipObject(keys, keys.map(key => userRoleFilter(key)));
    }
}
